export const InteresadoEntity = {
    id: null,
    numeroDocumento: '',
    nombres: '',
    apellidos: '',
    estadoCivil: '',
    direccion: '',
    telefono: '',
    email: '',
    tipoDocumento: 'DNI',
    departamento: '',
    provincia: '',
    distrito: '',
    ubigeo: '',
    fechaIngreso: null,
    enabled: true
};
